function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, borderRadius, spacing, breakpoints, themeLight } from '@naf/theme';
import { propValidationConfig } from '../propValidationConfig';
export let CardVariant = /*#__PURE__*/function (CardVariant) {
  CardVariant["Small"] = "small";
  CardVariant["Standard"] = "standard";
  CardVariant["Large"] = "large";
  CardVariant["Outline"] = "outline";
  return CardVariant;
}({});
export const BaseCard = /*#__PURE__*/forwardRef(({
  isNotClickable = false,
  isInternalLink = false,
  href,
  target,
  variant = CardVariant.Standard,
  children,
  linkProps,
  linkRef,
  ...rest
}, ref) => {
  if (isNotClickable || isInternalLink) {
    return /*#__PURE__*/React.createElement(Container, _extends({
      variant: variant,
      ref: ref
    }, rest), /*#__PURE__*/React.createElement(DivWrapper, {
      className: "card"
    }, children));
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    variant: variant,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(LinkWrapper, _extends({
    className: "card",
    href: href,
    target: target,
    ref: linkRef
  }, linkProps), children));
});
const wrapperStyling = css(["flex-basis:100%;width:fit-content;display:flex;text-decoration:none;border-bottom:1px solid;margin-bottom:", ";border-color:", ";"], spacing.space40, ({
  theme
}) => theme.border ? theme.border.subtle : themeLight.border.subtle);
const LinkWrapper = styled.a.withConfig({
  displayName: "BaseCard__LinkWrapper",
  componentId: "sc-piezbt-0"
})(["", ""], wrapperStyling);
const DivWrapper = styled.div.withConfig({
  displayName: "BaseCard__DivWrapper",
  componentId: "sc-piezbt-1"
})(["", ""], wrapperStyling);
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "BaseCard__Container",
  componentId: "sc-piezbt-2"
})(["display:flex;width:fit-content;width:", ";height:fit-content;height:", ";", ";a,a:visited,a:hover,a:active{color:", ";}.card{padding-bottom:", ";}", " ", " ", " ", " @media (max-width:", "){display:flex;width:100%;figure{height:4.5rem;width:6rem;margin-right:", ";}.card{padding-bottom:", ";margin-bottom:", ";}", "}"], ({
  width
}) => typeof width === 'number' ? `${width}px` : width, props => props.height, fontStyle.bodyText.bodyText, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, spacing.space40, ({
  variant
}) => variant === CardVariant.Small && css(["display:inline-flex;width:calc(33% - (", " * (2 / 3)));&:not(:nth-child(3n)){margin-right:", ";}figure{height:4.5rem;width:6rem;margin-right:", ";}.card{border:none;margin-bottom:0;}"], spacing.space32, spacing.space32, spacing.space16), ({
  variant
}) => variant === CardVariant.Standard && css(["figure{height:7.5rem;width:10rem;margin-right:", ";}"], spacing.space32), ({
  variant
}) => variant === CardVariant.Large && css(["figure{height:9rem;width:12rem;margin-right:", ";}"], spacing.space32), ({
  variant
}) => variant === CardVariant.Outline && css(["display:inline-flex;width:calc(33% - (", " * (2 / 3)));.card{padding:", ";border:1px solid;border-radius:", ";border-color:", ";}@media (max-width:", "){.card{padding:", ";svg{right:", ";top:0;}}}"], spacing.space32, spacing.space24, borderRadius.L, ({
  theme
}) => theme.border ? theme.border.subtle : themeLight.border.subtle, breakpoints.s, spacing.space16, spacing.space16), breakpoints.s, spacing.space16, spacing.space32, spacing.space32, ({
  variant
}) => variant === CardVariant.Small && css([".card{padding-bottom:0;}"]));
//# sourceMappingURL=BaseCard.js.map